module.exports = __webpack_public_path__ + "img/19.7701df60.jpg";